import { RGBColor } from "./types/rgb-color.type";

export const OBSTICLE_GROUND_OFFSET = 12;
export const OBSTICLE_HEIGHT = 48;

export const PRIMARY_COLOR: RGBColor = {
	r: 52,
	g: 143,
	b: 235,
};
